import { CallToAction, Grid, Header, Heading, StepList, TextAndMedia } from '@boltenergy-be/design-system'
import { useTranslation } from 'next-i18next/pages'
import { I18nUSP } from 'types/i18n'
import Link from 'components/link/Link'
import { routes } from 'utils/routes'
import ProducerCard from 'components/producer-card/ProducerCard'
import { UspsLocalProps } from 'features/usps/local/types'
import { useGetLanguage } from 'hooks/useGetLanguage'
import StartSimulationButton from 'components/start-simulation-button/StartSimulationButton'

const UspsLocal = ({ producers }: UspsLocalProps) => {
  // i18n
  const { t } = useTranslation('usps', { keyPrefix: 'local' })
  const language = useGetLanguage()

  return (
    <main>
      <Header title={t('header.title')} color="dark" shape="s5">
        <p>{t('header.description')}</p>
      </Header>

      <TextAndMedia
        title={t('intro.title')}
        media={{
          type: 'image',
          imageBehaviour: '1-1',
          props: { publicId: '/website/usps/local', fill: true, alt: '' }
        }}
      >
        <p>{t('intro.description')}</p>
      </TextAndMedia>

      <TextAndMedia
        inverse
        title={t('howItWorks.title')}
        media={{
          type: 'image',
          imageBehaviour: '3-4',
          props: { publicId: '/website/usps/how-it-works', fill: true, alt: '' }
        }}
      >
        <StepList size="large">
          {(t('howItWorks.steps', { returnObjects: true }) as Omit<I18nUSP, 'key'>[]).map(({ title, description }, index) => (
            <li key={`howItWorks-${index}`}>
              <div className="flex-col gap-100">
                <Heading as="h2" variant="h6" weight={500}>
                  {title}
                </Heading>
                <p>{description}</p>
              </div>
            </li>
          ))}
        </StepList>
      </TextAndMedia>

      {producers.length > 0 && (
        <Grid
          action={
            <Link representation="button" variant="secondary" href={routes(language).producers}>
              {t('producers.action')}
            </Link>
          }
          as="section"
          color="light"
          repeatCount="auto-fill"
          title={t('producers.title')}
        >
          {producers.map((producer) => (
            <ProducerCard key={producer.id} {...{ producer }} />
          ))}
        </Grid>
      )}

      <CallToAction title={t('cta.title')} color="accent-soft" shape="s6" action={<StartSimulationButton />}>
        <p>{t('cta.description')}</p>
      </CallToAction>
    </main>
  )
}

export default UspsLocal
